import { gspx } from '@rsos/capstone';

export const trackQueryByW3W = irpVersion => {
  gspx.trackCustomEvent('Universal Search', {
    irpVersion,
    name: `Query by W3W`,
    Category: 'What3words',
    'Launched date': new Date(),
  });
};

export const trackQueryByMAFID = irpVersion => {
  gspx.trackCustomEvent('Universal Search', {
    irpVersion,
    name: `Query by MAFID`,
    Category: 'MedicAlert',
    'Launched date': new Date(),
  });
};

export const trackClickOnSearchResult = (irpVersion, payloadID, requestID) => {
  gspx.trackCustomEvent('Data Jurisdiction', {
    irpVersion,
    name: 'Click on search result',
    Category: 'Jurisdiction View',
    'Launched date': new Date(),
    payloadID,
    requestID,
  });
};

export const trackQueryFromSearchBar = (
  userRoleName,
  irpVersion,
  payloadID,
  requestID,
  serviceType,
  classOfServices,
) => {
  gspx.trackCustomEvent('Data SearchBar', {
    irpVersion,
    name: `Query form by ${userRoleName}`,
    Category: 'Query View',
    'Launched date': new Date(),
    payloadID,
    requestID,
    serviceType,
    classOfServices,
  });
};
